import { useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { AFFILIATE_LINK } from "@/config";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SignupForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      await axios.post(`${API}/signups`, { name, email });
      setStatus("done");
      window.location.href = AFFILIATE_LINK;
    } catch {
      setStatus("error");
    }
  };

  return (
    <form
      id="get-access"
      onSubmit={submit}
      className="mx-auto w-full max-w-md scroll-mt-24 rounded-3xl bg-[var(--cream)] p-7 text-left text-[var(--ink)] shadow-[0_40px_80px_-40px_rgba(0,0,0,0.6)] sm:p-9"
      data-testid="signup-form"
    >
      <h3 className="font-display text-3xl font-light">Get Instant Access</h3>
      <p className="mt-2 text-sm text-[var(--muted)]">Enter your details below to unlock the Boss Suite.</p>
      <label className="mt-6 block text-sm font-semibold" htmlFor="su-name">First name</label>
      <input id="su-name" required value={name} onChange={(e) => setName(e.target.value)} autoComplete="given-name"
        className="mt-2 h-12 w-full rounded-xl border border-[var(--blush-deep)] bg-white px-4 text-base outline-none focus:border-[var(--mauve)] focus:ring-2 focus:ring-[var(--mauve)]/30"
        data-testid="signup-name-input" />
      <label className="mt-4 block text-sm font-semibold" htmlFor="su-email">Email</label>
      <input id="su-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email"
        className="mt-2 h-12 w-full rounded-xl border border-[var(--blush-deep)] bg-white px-4 text-base outline-none focus:border-[var(--mauve)] focus:ring-2 focus:ring-[var(--mauve)]/30"
        data-testid="signup-email-input" />
      <button type="submit" disabled={status === "loading" || status === "done"}
        className="mt-6 flex min-h-[56px] w-full items-center justify-center gap-2 rounded-full bg-[var(--mauve)] px-6 text-sm font-bold uppercase tracking-[0.14em] text-white transition-colors duration-300 hover:bg-[var(--mauve-dark)] disabled:opacity-80"
        data-testid="signup-submit-button">
        {status === "loading" && <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />}
        {status === "done" ? "Taking you there…" : "Yes, show me how"}
      </button>
      {status === "error" && (
        <p className="mt-3 text-sm font-medium text-red-700" role="alert" data-testid="signup-error">Something went wrong. Please try again.</p>
      )}
      <p className="mt-4 text-center text-xs text-[var(--muted)]">No spam. No sales calls.</p>
    </form>
  );
};
